import React from "react";

import { Input, Suffix, Wrap } from "./styles";

interface TextInputProps {
    value: string | null | undefined;
    onChange: (value: string) => void;
    placeholder?: string;
    suffix?: React.ReactNode;
    id?: string;
    type?: string;
    // Поле блокируем на время запроса, который его же и сохраняет.
    disabled?: boolean;
    className?: string;
}

export const TextInput = ({
    value,
    onChange,
    placeholder,
    suffix,
    id,
    type,
    disabled,
    className,
}: TextInputProps) => (
    <Wrap className={className}>
        <Input
            id={id}
            type={type}
            value={value ?? ""}
            placeholder={placeholder}
            disabled={disabled}
            $hasSuffix={!!suffix}
            onChange={(event) => onChange(event.target.value)}
        />
        {suffix && <Suffix>{suffix}</Suffix>}
    </Wrap>
);
